"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var memoize_one_1 = __importDefault(require("memoize-one"));
var Dropdown_1 = require("../Dropdown");
var GroupedSelectItem = function (props) {
    var content = props.content !== undefined ? props.content : props.text;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        props.index === 0 && props.group && (react_1.default.createElement("div", { className: "group" }, props.group)),
        react_1.default.createElement("span", { className: "text" }, content)));
};
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        var _this = _super.call(this, props) || this;
        _this.memoizedOptions = memoize_one_1.default(function (options, searchQuery, value, multiple) {
            var splitedOptions = _this.splitOptions(options, searchQuery, value, multiple);
            return __spreadArrays(_this.groupOptions(splitedOptions.available), splitedOptions.selected, splitedOptions.excluded);
        });
        _this.handleChange = function (event, data) {
            /*
             * search query is cleared every time Select is closed,
             * so if this.props.multiple !== true search query will be an empty string anyway
             * because Select will be closed after an element is selected
             */
            if (_this.searchQuery && _this.props.multiple) {
                var splittedOptions = _this.splitOptions(_this.props.options, _this.searchQuery, data.value, _this.props.multiple);
                // Semantic UI resets filter (without event firing) when selected last filtered element
                if (splittedOptions.available.length === 0) {
                    var searchData = __assign(__assign({}, data), { searchQuery: '' });
                    _this.handleSearchChange(event, searchData);
                }
            }
            data.value = data.value === '' ? undefined : data.value;
            if (_this.props.onChange) {
                _this.props.onChange(event, data);
            }
        };
        _this.handleSearchChange = function (event, data) {
            if (_this.props.grouped && !_this.props.hasOwnProperty('searchQuery')) {
                _this.setState({
                    searchQuery: data.searchQuery,
                });
            }
            if (_this.props.onSearchChange) {
                _this.props.onSearchChange(event, data);
            }
        };
        // Semantic UI resets filter (without event firing) on select close
        _this.handleClose = function (event, data) {
            var searchData = __assign(__assign({}, data), { searchQuery: '' });
            _this.handleSearchChange(event, searchData);
            if (_this.props.onClose) {
                _this.props.onClose(event, data);
            }
        };
        _this.splitOptions = memoize_one_1.default(function (options, searchQuery, value, multiple) {
            var available = [];
            var selected = [];
            var excluded = [];
            for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                var option = options_1[_i];
                if (multiple) {
                    if (Array.isArray(value) && value.includes(option.value)) {
                        selected.push(option);
                        continue;
                    }
                }
                if (!searchQuery ||
                    _this.isOptionSuitable(option, searchQuery)) {
                    available.push(option);
                }
                else {
                    excluded.push(option);
                }
            }
            return {
                available: available,
                selected: selected,
                excluded: excluded,
            };
        });
        _this.groupOptions = function (options) {
            var groups = options.reduce(function (result, current) {
                var group = current.group || '';
                if (!result[group]) {
                    result[group] = [];
                }
                result[group].push(current);
                return result;
            }, {});
            return [].concat.apply([], Object.keys(groups)
                .sort()
                .map(
            // sorting groups and converting them to the collection
            function (group) {
                return groups[group].map(function (option, index) { return (__assign(__assign({}, option), { index: index, className: classnames_1.default(option.className, index === 0 && 'with-group'), content: (react_1.default.createElement(GroupedSelectItem, __assign({ index: index }, option))) })); });
            }));
        };
        _this.state = {
            searchQuery: '',
        };
        return _this;
    }
    Object.defineProperty(Select.prototype, "searchQuery", {
        get: function () {
            return this.props.hasOwnProperty('searchQuery')
                ? this.props.searchQuery
                : this.props.grouped
                    ? this.state.searchQuery
                    : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "options", {
        get: function () {
            if (!this.props.grouped) {
                return this.props.options;
            }
            return this.memoizedOptions(this.props.options, this.searchQuery, this.props.value, this.props.multiple);
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.isOptionSuitable = function (option, searchQuery) {
        if (option.text == null) {
            return true;
        }
        return option.text
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase());
    };
    Select.prototype.render = function () {
        var _a = this.props, className = _a.className, grouped = _a.grouped, large = _a.large, onChange = _a.onChange, onClose = _a.onClose, onSearchChange = _a.onSearchChange, options = _a.options, size = _a.size, small = _a.small, value = _a.value, props = __rest(_a, ["className", "grouped", "large", "onChange", "onClose", "onSearchChange", "options", "size", "small", "value"]);
        var realSize = size;
        if (small)
            realSize = 'small';
        if (large)
            realSize = 'large';
        var SelectClasses = classnames_1.default('Select', className, {
            'Select--small': realSize === 'small',
            'Select--large': realSize === 'large',
            'Select--grouped': grouped,
        });
        var realValue = value === undefined ? (this.props.multiple ? [] : '') : value;
        return (react_1.default.createElement(Dropdown_1.Dropdown, __assign({}, props, { options: this.options, value: realValue, onChange: this.handleChange, onSearchChange: this.handleSearchChange, onClose: this.handleClose, className: SelectClasses })));
    };
    Select.defaultProps = {
        selection: true,
        size: 'medium',
    };
    return Select;
}(react_1.Component));
exports.Select = Select;
//# sourceMappingURL=Select.js.map